import cn from 'classnames';

export const Counter = ({ amount = 0, bgColor, onClick }) => {
  return (
    <span
      onClick={onClick}
      className={cn(
        'inline-block px-1 text-xs text-white font-semibold cursor-pointer',
        bgColor
      )}
    >
      {amount}
    </span>
  );
};
